import SvgApiExplorerHome from '@squareup/dex-icons/dex/misc/ApiExplorerHome';
import { Box, Display10, Paragraph30 } from '@squareup/dex-ui-shared-base';
import { MarketButton } from '@squareup/dex-ui-shared-market';
import React, { FC } from 'react';

import styles from './content-layout.module.css';

const strings = {
  homeButton: 'Back to home',
};

interface Props {
  title: string;
  description?: string;
  showHomeButton?: boolean;
}

const ApiExplorerErrorPageLayout: FC<Props> = ({
  title,
  description,
  showHomeButton = false,
}) => {
  return (
    <Box
      className={styles['error-content']}
      padding={{ vertical: '4x', horizontal: '4x' }}
    >
      <SvgApiExplorerHome />
      <Box>
        <Display10 margin={{ bottom: '1x' }}>{title}</Display10>
        <Paragraph30 colorVariant="20">{description}</Paragraph30>
        {showHomeButton && (
          <Box margin={{ top: '1x' }}>
            <MarketButton
              href="/explorer/square"
              trackingId="explorer-error-home-button"
              rank="primary"
            >
              {strings.homeButton}
            </MarketButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export { ApiExplorerErrorPageLayout };
